export const UI_DATE_FORMAT = 'MMM, DD, YYYY h:mm A';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
